import React, { Component } from 'react';
import 'whatwg-fetch'
import { connect } from 'react-redux';

import {db} from './state';
import {loadMore} from './appActions';
import ReplayListItem from './components/ReplayListItem';
import Loader from './components/loader';
import Filter from './components/filter'

class App extends Component {
  render() {
    let pr = this.props;
    return (
    <div>
      <Filter filters={this.props.filters}/>
      <div>
        {this.props.replays.map( (r) => {
            return (
                <ReplayListItem key={'rep' + r.id} replay={r}/>
            )
        })}

        {
          !this.props.replays.length && pr.lastPage ?
            <div className="empty_list">
              <div className="text-lg">Ничего не найдено!</div>
              <div className="text-sm">Попробуйте сменить параметры фильтра</div>
            </div>
            : null
        }
      </div>
      <Loader show={pr.lastPage !== pr.waitPage}/>
    </div>
    );
  }

  componentDidMount() {
    db.loadList('replay', {sortable: 'true'});
  }

  componentWillUpdate(nextProps) {
    let pr = nextProps;
    scrollToBottom(pr.loadMore, pr.lastPage, pr.waitPage, pr.totalPages);
  }
}

function scrollToBottom (loadMore,  lastPage, waitPage, totalPages) {
  window.onscroll = () => {
    let delta = 400;
    let current = window.pageYOffset + document.documentElement.clientHeight;
    let pageHeight = document.documentElement.scrollHeight;

    if (current + delta > pageHeight && lastPage === waitPage && lastPage < totalPages) {
        loadMore(lastPage);
    }
  }
}

function mapStateToProps(state) {
  db.begin(state.db);

  let lastPage = state.app.paging.current;
  let totalPages = state.app.paging.total;
  let waitPage = state.app.waitPage;

  return {
    'replays': db.replay.all().toModelArray() || [],
    lastPage,
    waitPage,
    totalPages,
  }
}

function mapAppActions(dispatch) {
  return {
    loadMore: lastPage => {
      dispatch(loadMore(lastPage));
    },
  }
}

export default connect(mapStateToProps, mapAppActions)(App);



// WEBPACK FOOTER //
// ./src/App.js